import { GroupTypeBase, Styles } from "react-select";
import { colors } from "../../styles/variables";
import { ReactSelectDropdownOption } from "../../../index";
import { ThemeInterface } from "../../theme/theme";

export const customReactSelectStyles: Partial<
  Styles<ReactSelectDropdownOption, false>
> = {
  container: (provided) => ({
    ...provided,
    minWidth: "74px",
  }),
  valueContainer: (provided) => ({
    ...provided,
    flexWrap: "initial",
  }),
  control: (provided) => ({
    ...provided,
    borderRadius: 0,
    minHeight: "40px",
    backgroundColor: "transparent",
  }),
  singleValue: () => ({
    textAlign: "center",
    width: "100%",
    marginLeft: "32px",
  }),
  indicatorSeparator: () => ({
    visibility: "hidden",
  }),
  menu: (provided) => ({
    ...provided,
    marginTop: 1,
    borderRadius: 0,
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: 220,
  }),
  option: (provided, { isSelected, isFocused }) => ({
    ...provided,
    textAlign: "center",
    backgroundColor: isSelected
      ? colors.gray
      : isFocused
      ? colors.lightGray
      : "transparent",
  }),
};

export const getThemedSelectQtyStyles = (
  theme: ThemeInterface
): Partial<Styles<ReactSelectDropdownOption, false>> => {
  return {
    ...customReactSelectStyles,
    option: (provided, { isSelected, isFocused }) => ({
      ...provided,
      textAlign: "center",
      ...(theme.isDarkMode && { color: colors.black }),
      backgroundColor: isSelected
        ? colors.gray
        : isFocused
        ? colors.lightGray
        : "transparent",
    }),
    control: (provided) => ({
      ...provided,
      borderColor: colors.mediumGray,
      backgroundColor: "transparent",
      borderRadius: 2,
      minHeight: 0,
      height: 31,
      width: 74,
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      padding: "0 10px 0 0",
      color: colors.mediumGray,
      "& div": {
        padding: 0,
      },
    }),
    singleValue: () => ({
      margin: "0 auto",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: 0,
      width: "100%",
    }),
  };
};

export const customReactSelectQtyStyles:
  | Partial<
      Styles<
        ReactSelectDropdownOption,
        false,
        GroupTypeBase<ReactSelectDropdownOption>
      >
    >
  | undefined = {
  ...customReactSelectStyles,
  control: (provided) => ({
    ...provided,
    borderColor: colors.mediumGray,
    backgroundColor: "transparent",
    borderRadius: 2,
    minHeight: 0,
    height: 31,
    width: 74,
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    padding: "0 10px 0 0",
    color: colors.mediumGray,
    "& div": {
      padding: 0,
    },
  }),
  singleValue: () => ({
    margin: "0 auto",
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: 0,
    width: "100%",
  }),
};

export const customReactSelectTypeableStyles: Partial<
  Styles<ReactSelectDropdownOption, false>
> = {
  ...customReactSelectStyles,
  valueContainer: (provided) => ({
    ...provided,
    flexWrap: "inherit",
    height: 20,
  }),
  control: (provided) => ({
    ...provided,
    borderColor: colors.lightestGray,
    backgroundColor: "transparent",
    borderRadius: 2,
    minHeight: 0,
    height: 30,
    width: 92,
  }),
  input: (provided) => ({
    ...provided,
    flex: 1,
    textAlign: "start",
    position: "absolute",
    margin: "0px",
    padding: "0px",
    left: "15px",
    top: "0px",
    lineHeight: "20px",
    "> div": {
      position: "absolute",
      top: "0px",
    },
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    padding: "0 10px 0 0",
    color: colors.mediumGray,
    "& div": {
      padding: 0,
    },
  }),
  singleValue: () => ({
    textAlign: "start",
    position: "absolute",
    top: "0px",
    left: "15px",
    lineHeight: "20px",
  }),
};
